










































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta';
import { Resolve } from 'vue-di';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { mapKeys } from 'lodash';
import ISIInfo from '~/components/isi-info/isi-info.vue';
import Footer from '~/components/Footer/Footer.vue';
import theme from '~/settings/theme';
import SessionModule from '~/store/session';
import LayoutModule from '~/store/layout';
import IriModule from '~/store/iri';
import FooterModule from '~/store/footer';
import styles from '~/assets/style/variables.scss';

@Component<FloatingFooter>({
    components: {
        isiInfo: ISIInfo,
        Footer,
    },
    icons: {
        faChevronUp,
        faChevronDown,
    },
    created() {},
})
export default class FloatingFooter extends Vue {
    @Resolve
    public iri!: IriModule;

    @Resolve footer!: FooterModule

    public win = {
        h: 0,
        y: 0,
        x: 0,
    };

    public doc = {
        h: 0,
        w: 0,
    };

    public footerTrayStatus = "normal"; // values can be normal, expand or collapse
    public isIntersecting = false; // to track whether fixed footer is in view or not
    public showTwoColInMobile = true;

    onIntersect (entries: any) {
        this.isIntersecting = entries[0].isIntersecting
    };

    public headerHeight: number = 0;

    // iOS Safari (and some Android browsers) size `vh` against the *largest* viewport — i.e.
    // with the URL bar hidden — so a footer positioned with `vh` gets tucked behind the bottom
    // URL bar when it's showing. `svh` sizes against the *smallest* viewport (URL bar visible),
    // which keeps the floating footer on screen. Fall back to `vh` where `svh` isn't supported
    // (iOS < 15.4 / older Android) so behavior on those devices is unchanged.
    public get viewportUnit(): string {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('height', '1svh')) {
            return 'svh';
        }
        return 'vh';
    }

    // to handle the isi tray height according to status anf header height
    public get handleTrayHeight() {
        const unit = this.viewportUnit;

        if (this.footerTrayStatus === "expand") {
            return window.innerWidth < 500 ? `top: 20${unit}` : `top: 15${unit}`;
        }

        else if (this.footerTrayStatus === "collapse") {
            return `top: calc(100${unit} - ${this.headerHeight - 1}px)`;
        }
        else{
            return window.innerWidth < 500 ? `top: 50${unit}` : `top: 72${unit}`;
        }

    }

    // to update tray status and to fetch and store the tray header height
    public updateTrayStatus(status: string) {
        this.showTwoColInMobile = status == 'normal' ? true : false;
        this.footerTrayStatus = status;

        this.$nextTick(() => {
            const headerSection = this.$el.querySelector('.footer-isi-tray-heading-wrapper') as HTMLElement;

            if (headerSection) {
                this.headerHeight = headerSection.offsetHeight;
            }
        });
    }

    // calculating the scrollable height for the isi info div
    public get scrollableHeight(): number {
        let topOffset: number;

        if (this.footerTrayStatus === "expand") {
            topOffset = window.innerWidth < 500 ? window.innerHeight * 0.2 : window.innerHeight * 0.15;
        } else if (this.footerTrayStatus === "collapse") {
            topOffset = window.innerHeight - (this.headerHeight - 1);
        } else {
            topOffset = window.innerWidth < 500 ? window.innerHeight * 0.5 : window.innerHeight * 0.72;
        }

        const padding = 32;
        return window.innerHeight - topOffset - padding;
    }

    public fixedFooter = {
        h: 0,
        w: 0,
    };

    public get staticFooter() {
        return this.footer.staticFooter;
    }

    public get iriOpen() {
        return this.iri.open;
    }

    public set iriOpen(v) {
        this.iri.toggleIriOpen(v);
    }

    public get aboveStaticFooter() {
        return this.win.y + this.win.h - this.fixedFooter.h < this.staticFooter.y;
    }

    public get brkPoints() {
        return {
            'brk-xs': this.$vuetify.breakpoint.xs,
            'brk-xs-only': this.$vuetify.breakpoint.xsOnly,
            'brk-sm': this.$vuetify.breakpoint.sm,
            'brk-sm-only': this.$vuetify.breakpoint.smOnly,
            'brk-sm-and-down': this.$vuetify.breakpoint.smAndDown,
            'brk-sm-and-up': this.$vuetify.breakpoint.smAndUp,
            'brk-md': this.$vuetify.breakpoint.md,
            'brk-md-only': this.$vuetify.breakpoint.mdOnly,
            'brk-md-and-down': this.$vuetify.breakpoint.mdAndDown,
            'brk-md-and-up': this.$vuetify.breakpoint.mdAndUp,
            'brk-lg': this.$vuetify.breakpoint.lg,
            'brk-lg-only': this.$vuetify.breakpoint.lgOnly,
            'brk-lg-and-down': this.$vuetify.breakpoint.lgAndDown,
            'brk-lg-and-up': this.$vuetify.breakpoint.lgAndUp,
            'brk-xl': this.$vuetify.breakpoint.xl,
            'brk-xl-only': this.$vuetify.breakpoint.xlOnly,
        };
    }

    handleClick() {
        this.aboveStaticFooter
            ? this.$vuetify.goTo('#fixed-footer', {
                  duration: 1000,
                  easing: 'easeInOutCubic',
                  offset: 0,
              })
            : this.$vuetify.goTo('#main-layout', {
                  duration: 1000,
                  easing: 'easeInOutCubic',
                  offset: 0,
              });
    }

    mounted() {
        this.updateWindow();
    }

    public updateWindow(): void {
        this.win = {
            h: window.innerHeight as number,
            x: window.innerHeight as number,
            y: window.pageYOffset as number,
        };
        const fixedFooter = document.querySelector('#fixed-footer') as HTMLElement | null;
        const staticFooter = document.querySelector('#static-footer') as HTMLElement | null;
        const doc = document.body as HTMLElement;
        if (fixedFooter) {
            this.fixedFooter = {
                h: fixedFooter.offsetHeight,
                w: fixedFooter.offsetWidth,
            };
        }
        if (staticFooter) {
            this.footer.setStaticFooter({
                y: staticFooter.offsetTop
            });
        }
        this.doc = {
            h: doc.offsetHeight,
            w: doc.offsetWidth,
        };
    }
}
